import ddt from '@wix/da-ddt';
export const autoScroll = (distanceFromBottom, distanceToScroll, editor, scrollContainer)=>{
    const { selection } = editor.state;
    // Dont scroll unless we are typing
    if (!selection.empty) {
        return;
    }
    const isThatShitBrowserSafari = 'WebkitAppearance' in document.documentElement.style && !/Chrome/.test(navigator.userAgent);
    if (scrollContainer) {
        // Container scrolling
        const viewportCoords = editor.view.coordsAtPos(selection.from);
        const scrollContainerRect = scrollContainer.getBoundingClientRect();
        const containerOffset = scrollContainerRect.top;
        const absoluteOffset = scrollContainer.scrollTop + (viewportCoords.top - scrollContainerRect.top) - window.scrollY;
        const containerRect = scrollContainer.getBoundingClientRect();
        ddt.log('editorautoscroller', 'Auto-Calc', {
            viewportCoords,
            absoluteOffset,
            containerRect,
            distanceFromBottom,
            scrollContainer,
            scTop: scrollContainer.scrollTop,
            win: window.scrollY,
            chk: viewportCoords.bottom - containerOffset >= containerRect.height - distanceFromBottom,
            scrollContainerRect
        });
        if (viewportCoords.bottom - containerOffset >= containerRect.height - distanceFromBottom) {
            const elementBottomRelativeToContainer = viewportCoords.top - scrollContainerRect.top;
            ddt.log('editorautoscroller', 'Auto-Scrolled');
            if (isThatShitBrowserSafari) {
                scrollContainer.scrollTo({
                    top: elementBottomRelativeToContainer - scrollContainer.clientHeight + scrollContainer.scrollTop + distanceToScroll,
                    left: scrollContainer.scrollLeft
                });
            } else {
                scrollContainer.scrollTo({
                    behavior: 'smooth',
                    top: elementBottomRelativeToContainer - scrollContainer.clientHeight + scrollContainer.scrollTop + distanceToScroll,
                    left: scrollContainer.scrollLeft
                });
            }
        }
    } else {
        var _visualViewport, _visualViewport1;
        // Window scrolling
        const viewportCoords = editor.view.coordsAtPos(selection.from);
        const absoluteOffset = window.scrollY + viewportCoords.top;
        ddt.log('editorautoscroller', 'Auto-Scrolled', {
            viewportCoords,
            absoluteOffset,
            height: (_visualViewport = visualViewport) === null || _visualViewport === void 0 ? void 0 : _visualViewport.height,
            distanceFromBottom
        });
        var _visualViewport_height;
        if (viewportCoords.bottom >= ((_visualViewport_height = (_visualViewport1 = visualViewport) === null || _visualViewport1 === void 0 ? void 0 : _visualViewport1.height) !== null && _visualViewport_height !== void 0 ? _visualViewport_height : 0) - distanceFromBottom) {
            if (isThatShitBrowserSafari) {
                var _visualViewport2;
                var _visualViewport_height1;
                window.scrollTo({
                    top: absoluteOffset - ((_visualViewport_height1 = (_visualViewport2 = visualViewport) === null || _visualViewport2 === void 0 ? void 0 : _visualViewport2.height) !== null && _visualViewport_height1 !== void 0 ? _visualViewport_height1 : 0) + distanceToScroll,
                    left: window.scrollX
                });
            } else {
                var _visualViewport3;
                var _visualViewport_height2;
                window.scrollTo({
                    top: absoluteOffset - ((_visualViewport_height2 = (_visualViewport3 = visualViewport) === null || _visualViewport3 === void 0 ? void 0 : _visualViewport3.height) !== null && _visualViewport_height2 !== void 0 ? _visualViewport_height2 : 0) + distanceToScroll,
                    left: window.scrollX,
                    behavior: 'smooth'
                });
            }
        }
    }
};

//# sourceMappingURL=autoScroll.js.map